// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlueCheckBoxLabel p,
label {
    font:
        1rem "Fira Sans",
        sans-serif;
    color: white;
}

.BlueCheckBoxInput input {
    margin: 0.4rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/BlueCheckBox/BlueCheckBox.css"],"names":[],"mappings":"AAAA;;IAEI;;kBAEc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".BlueCheckBoxLabel p,\nlabel {\n    font:\n        1rem \"Fira Sans\",\n        sans-serif;\n    color: white;\n}\n\n.BlueCheckBoxInput input {\n    margin: 0.4rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
